export default {
  "branchLocator": {
    "webform": {
      "yes": "是",
      "no": "否",
      "cancel": "取消",
      "submit": "提交",
      "displayHead": "分行及自助理財中心地址",
      "output": "請填寫以下表格：",
      "hints": "提示",
      "areas": "區域：",
      "areasOptions": "[{\"text\":\"香港島\",\"value\":\"Hong Kong Island\"},{\"text\":\"九龍西\",\"value\":\"Kowloon West\"},{\"text\":\"九龍東\",\"value\":\"Kowloon East\"},{\"text\":\"新界西\",\"value\":\"New Territories West\"},{\"text\":\"新界東\",\"value\":\"New Territories East\"}]",
      "districts": "地區：",
      "districtsAll": "[\"Hong Kong Island\",\"Kowloon West\",\"Kowloon East\",\"New Territories West\",\"New Territories East\"]",
      "districtsOptions": {
        "hongKongIsland": "[{\"text\":\"中西區\",\"value\":\"Central & Western\"},{\"text\":\"灣仔\",\"value\":\"Wanchai\"},{\"text\":\"東區\",\"value\":\"Eastern\"},{\"text\":\"南區\",\"value\":\"Southern\"}]",
        "kowloonWest": "[{\"text\":\"油尖旺\",\"value\":\"Yau Tsim Mong\"},{\"text\":\"深水埗\",\"value\":\"Sham Shui Po\"},{\"text\":\"九龍城\",\"value\":\"Kowloon City\"}]",
        "kowloonEast": "[{\"text\":\"黃大仙\",\"value\":\"Wong Tai Sin\"},{\"text\":\"觀塘\",\"value\":\"Kwun Tong\"}]",
        "newTerritoriesWest": "[{\"text\":\"荃灣\",\"value\":\"Tsuen Wan\"},{\"text\":\"屯門\",\"value\":\"Tuen Mun\"},{\"text\":\"元朗\",\"value\":\"Yuen Long\"},{\"text\":\"葵青\",\"value\":\"Kwai Tsing\"},{\"text\":\"離島\",\"value\":\"Outlying Islands\"}]",
        "newTerritoriesEast": "[{\"text\":\"北區\",\"value\":\"North\"},{\"text\":\"大埔\",\"value\":\"Tai Po\"},{\"text\":\"沙田\",\"value\":\"Shatin\"},{\"text\":\"西貢\",\"value\":\"Sai Kung\"}]"
      },
      "branch": "分行及自助理財中心",
      "address": "地址",
      "specificServicesSymbol": "特定服務圖示",
      "securitiesLong": "證券服務",
      "securities": "SEC",
      "safeboxLong": "保管箱服務",
      "safebox": "SDB",
      "currenciesEmpty": "請選擇貨幣",
      "areasEmpty": "請選擇區域",
      "serviceTypesEmpty": "請選擇服務類型",
      "pleaseSelect": "請選擇",
      "serviceTypes": "服務類型：",
      "serviceTypesOptions": "[{\"text\":\"分行\",\"value\":\"Branches\"},{\"text\":\"外幣及人民幣自動櫃員機\",\"value\":\"FOREX\"}]",
      "currencies": "貨幣：",
      "currenciesOptions": "[{\"text\":\"澳元\",\"value\":\"AUD\",\"8notes\":\"true\",\"12notes\":\"true\"},{\"text\":\"加元\",\"value\":\"CAD\",\"8notes\":\"true\",\"12notes\":\"true\"},{\"text\":\"瑞士法郎\",\"value\":\"CHF\",\"8notes\":\"false\",\"12notes\":\"true\"},{\"text\":\"歐羅 \",\"value\":\"EUR\",\"8notes\":\"true\",\"12notes\":\"true\"},{\"text\":\"英鎊\",\"value\":\"GBP\",\"8notes\":\"true\",\"12notes\":\"true\"},{\"text\":\"日圓\",\"value\":\"JPY\",\"8notes\":\"true\",\"12notes\":\"true\"},{\"text\":\"韓元\",\"value\":\"KRW\",\"8notes\":\"false\",\"12notes\":\"true\"},{\"text\":\"新西蘭元\",\"value\":\"NZD\",\"8notes\":\"false\",\"12notes\":\"true\"},{\"text\":\"人民幣\",\"value\":\"RMB\",\"8notes\":\"true\",\"12notes\":\"true\"},{\"text\":\"新加坡元\",\"value\":\"SGD\",\"8notes\":\"false\",\"12notes\":\"true\"},{\"text\":\"泰銖\",\"value\":\"THB\",\"8notes\":\"true\",\"12notes\":\"true\"},{\"text\":\"新台幣\",\"value\":\"TWD\",\"8notes\":\"true\",\"12notes\":\"true\"},{\"text\":\"美元\",\"value\":\"USD\",\"8notes\":\"true\",\"12notes\":\"true\"}]",
      "unauthorizedAPI": "無效的API金鑰"
    },
    "confirmSubmit": {
      "branchOutput": "以下為恆生分行及自助理財中心地址於<b style='color:#33A343;'>{districts}區</b>的位置： ",
      "forexOutputWithDistrict": "以下為恆生外幣及人民幣自動櫃員機於<b style='color:#33A343;'>{districts}區</b>的位置：",
      "forexNoResultWithDistrict": "你所選取的地區並沒有提供此外幣提款機服務，請親臨分行進行兌換。<br>以下為恆生分行及自助理財中心於<b style='color:#33A343;'>{districts}區</b>的位置：",
      "forexNoResultWithDistrict1": "<b style='color:#33A343;'>{districts}區</b>快將提供<b>{listOfCurrencies}</b>的外幣提款機服務，現在你亦可親臨分行提取相關外幣。<br>以下為恆生分行及自助理財中心於<b style='color:#33A343;'>{districts}區</b>的位置：",     
      "forexNoResultWithDistrict2": "<b style='color:#33A343;'>{districts}區</b>目前只能提供<b>{supportedCurrencies}</b>外幣提款機服務，尚未提供<b>{nonSupportedCurrencies}</b>外幣提款機服務，但你亦可親臨分行提取相關外幣。<br>以下為恆生分行及自助理財中心於<b style='color:#33A343;'>{districts}區</b>的位置：", 
      "forexNoResultWithDistrict3": "<b style='color:#33A343;'>{districts}區</b>快將提供外幣提款機服務，現在你亦可親臨分行提取相關外幣。<br>以下為恆生分行及自助理財中心於<b style='color:#33A343;'>{districts}區</b>的位置：",
      "forexNoResultWithDistrict4": "以下為提供<b>{supportedCurrencies}</b>的恆生外幣及人民幣自動櫃員機於<b style='color:#33A343;'>{districts}區</b>的位置：",
      "branchNoResult": "你所選取的地區並沒有提供此項服務。你可嘗試其他地區。",
      "learnMore": "了解更多",
      "modify": "更改區域及地區",
      "actionBtn": {
        "label": "服務時間",
        "link": "https://www.hangseng.com/en-hk/contact-us/branch-addresses/"
      }
    },
    "result": {
      "serviceDetails": "服務詳情",
      "serviceInfo": {
        "branch": "分行：",
        "weekdays": "星期一至五",
        "sat": "星期六",
        "sun": "星期日",
        "serviceHour": "服務時間",
        "automatedBankingMachineServiceHours": "自動櫃員機服務時間",
        "branchServices": "分行服務",
        "fxAtmServices": "自動櫃員機服務"
      }
    },
    "forexMultiSelect": {
      "pleaseSelect": "請選擇",
      "selectAll": "選擇所有",
      "deselectAll": "取消選擇所有",
      "currenciesSelectedAll": "全選",
      "currenciesSelectedAllDefault": "全選（預設）",
      "currenciesSelected": "已選",
      "currenciesCustom":"自訂"
    },
    "typeModal": {
      "header": "外幣提款機提供外幣種類",
      "content": "恒生外幣提款機的外幣提取服務多達12種外幣。部分服務地點只提供8種外幣的現鈔提款服務。",
      "currencies": "貨幣",
      "8notes": "8種外幣",
      "12notes": "12種外幣",
      "print": "列印"
    }
  }
}